import React, { useState, useEffect } from "react";
import { SafeAreaView, StyleSheet, ScrollView, Platform, View } from "react-native";
import { useTheme } from "react-native-paper";
import CustomAssessment from "../../../components/AssessmentBuilderCmponent/Assessment/CustomAssessment";
import { generateUniqueID } from "../../../components/SurveyBuilderComponent/CreateSurvey/CreateSurveyFunctions";
import { useAssessment } from "../../../hooks/useAssessment";

const EditAssessment = (props) => {
  const { colors } = useTheme();
  const styles = makeStyles(colors);
  const { loadParticipants } = useAssessment();

  const [sectionQuestionList, setSectionQuestionList] = useState([]);
  const [assm, setAssm] = useState({});
  const [Editable, setEditable] = useState(1);
  const [participants, setParticipants] = useState([]);

  // * Map from ASSMTYPES
  const questionLineTypeToIndex = [
    { label: "Text", value: 2 },
    { label: "Slider", value: 21 },
    { label: "Essay", value: 6 },
    { label: "Scale", value: 5 },
    { label: "Scale", value: 12 },
    { label: "Boxes", value: 23 },
    { label: "TCC", value: 10 },
  ];

  const loadParticipations = () => {
    loadParticipants(props.assmUi)
      .then((respEmployee) => {
        setParticipants(respEmployee);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    loadParticipations();
  }, []);

  useEffect(() => {
    if (participants.length !== 0) {
      setEditable(0);
    }
  }, [participants]);

  useEffect(() => {
    getSectionQuestions();
  }, [props.prevAssm]);

  useEffect(() => {
    getAssm();
  }, [props.prevAssm]);

  const getAssm = () => {
    setAssm({
      id: props.assmUi,
      assm_group_id: props.prevAssm.assmGroupUi,
      organization_id: "8F844600-801E-41C7-ABF0-27F80CDFB625",
      assm_title: props.prevAssm.description,
      assm_instructions: props.prevAssm.instructions,
      assm_from_date: props.prevAssm.assmFromDate,
      assm_to_date: props.prevAssm.assmToDate,
      assm_allowChangeOfAppraiser: props.prevAssm.allowChangeOfAppraiser,
      assm_type: props.prevAssm.assmType,
      assm_company: props.prevAssm.assmCompany,
      require_login: true,
    })
  }

  const getSectionQuestions = () => {
    const newSectionQuestionList = [];
    for (var i = 0; i < props.prevAssm.assmSect.length; i++) {
      var sectionData = {
        id: props.prevAssm.assmSect[i].sectionUi,
        assm_header_id: props.prevAssm.assmSect[i].assmUi,
        section_name: props.prevAssm.assmSect[i].description,
        section_instructions: props.prevAssm.assmSect[i].instructions,
        section_url_img:props.prevAssm.assmSect[i].section_url_img,
        isSectionCover:props.prevAssm.assmSect[i].isSectionCover,
        graphAxis:props.prevAssm.assmSect[i].graphAxis,
        useOnGraph:props.prevAssm.assmSect[i].useOnGraph,
        section_required_yn: 0,
        section_order: props.prevAssm.assmSect[i].sectionId,
        section_quantitative: props.prevAssm.assmSect[i].isQuantitative,
        section_showResults: props.prevAssm.assmSect[i].isResult,
        section_hideComparison: props.prevAssm.assmSect[i].hideMeetingComparison,
        section_rotw: props.prevAssm.assmSect[i].readOnlyToWhom,
        section_rot: props.prevAssm.assmSect[i].readOnlyToWhom,
        section_weight: props.prevAssm.assmSect[i].weight,
        section_questions: [],
      };

      for (var j = 0; j < props.prevAssm.assmSect[i].assmQuest.length; j++) {
        const typeId = props.prevAssm.assmSect[i].assmQuest[j].assmQuestLineTypeId;
        const foundItem = questionLineTypeToIndex.find(item => item.value === typeId);
        const label = foundItem ? foundItem.label : "Text"
        var questionData = {
          id: props.prevAssm.assmSect[i].assmQuest[j].questUI,
          parent_id: "",
          assm_section_id: props.prevAssm.assmSect[i].assmQuest[j].sectionUI,
          question_subtext: "",
          question_required_yn: props.prevAssm.assmSect[i].assmQuest[j].isRequired,
          question_name: props.prevAssm.assmSect[i].assmQuest[j].description,
          question_order: props.prevAssm.assmSect[i].assmQuest[j].questId,
          input_type_id: typeId,
          input_type_name: label,
          quest_instructions: props.prevAssm.assmSect[i].assmQuest[j].instructions,
          question_weight: props.prevAssm.assmSect[i].assmQuest[j].weight,
          questImgUrl:props.prevAssm.assmSect[i].assmQuest[j].questImgUrl,
          isQuestionCover:props.prevAssm.assmSect[i].assmQuest[j].isQuestionCover,
          allow_mutiple_option_answers_yn: 0,
          dependent_question_id: generateUniqueID(),
          dependent_question_option_id: generateUniqueID(),
          dependent_answer_id: generateUniqueID(),
          option_group_id: "9EF9EC42-2E58-4CEF-93A4-4C3C63C2FBE0",
          question_lines: [],
          question_options: [
            {
              id: generateUniqueID(),
              question_id: props.prevAssm.assmSect[i].assmQuest[j].questUI,
              fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
              fk_option_choice_name: "",
              question_option_name: "",
              option_order: 0,
            },
          ],
        };

        for (var k = 0; k < props.prevAssm.assmSect[i].assmQuest[j].assmQuestLine.length; k++) {
          const typeId = props.prevAssm.assmSect[i].assmQuest[j].assmQuestLine[k].assmQuestLineTypeId;
          const foundItem = questionLineTypeToIndex.find(item => item.value === typeId);
          const label = foundItem ? foundItem.label : "Text"
          var questionLineData = {
            id: props.prevAssm.assmSect[i].assmQuest[j].assmQuestLine[k].questLineUI,
            question_id: props.prevAssm.assmSect[i].assmQuest[j].assmQuestLine[k].questUI,
            question_line_order: props.prevAssm.assmSect[i].assmQuest[j].assmQuestLine[k].lineId,
            question_line_description: props.prevAssm.assmSect[i].assmQuest[j].assmQuestLine[k].description,
            input_type_name: label,
            input_type_id: typeId,
            weight: props.prevAssm.assmSect[i].assmQuest[j].weight / props.prevAssm.assmSect[i].assmQuest[j].assmQuestLine.length,
          };
          questionData.question_lines.push(questionLineData);
        }
        sectionData.section_questions.push(questionData);
      }
      newSectionQuestionList.push(sectionData);
    }
    setSectionQuestionList(newSectionQuestionList)
  }


  return (
    <SafeAreaView style={[styles.main]}>
       <View style={styles.listWrapper}>
      <ScrollView>
        <View style={styles.row_elements}>
          <CustomAssessment 
            groups={props.data[0]}
            company={props.data[1]}
            workflows={props.data[2]}
            question_types={props.data[3]}
            setWfl={props.setWfl}
            assm={assm}
            setAssm={setAssm}
            Editable={Editable}
            setAssmUi={props.setAssmUi}
            assmUi={props.assmUi}
            sectionQuestionList={sectionQuestionList}
            setSectionQuestionList={setSectionQuestionList}
            setShowParticipationsScreen={props.setShowParticipationsScreen}
            setShowResponseScreen={props.setShowResponseScreen}
            setShowEditScreen={props.setShowEditScreen}
            setShowEditGroup={props.setShowEditGroup}
            setShowCreateScreen={props.setShowCreateScreen}
            setShowCreateGroup={props.setShowCreateGroup}
            setShowMyAssessments={props.setShowMyAssessments}
            isCreate={0}
            toView={0}
            isEdit={1}
            setShowAssessmentsAdmin={props.setShowAssessmentsAdmin}
          />
        </View>
      </ScrollView>
      </View>
    </SafeAreaView>
  );
};

const makeStyles = (colors, height, width) =>
  StyleSheet.create({
    main: {
      flex: 1,
    },
    listWrapper: {
      flex:1,
      padding:10,
      marginBottom: 10,
     
  }, 
    row_elements: {
      flex: 1,
      flexDirection: "row",
      justifyContent: "center",
      margin: "1%",
      borderRadius: 5,
      elevation: 5,
      shadowOffset: { width: 0, height: 0 },
      backgroundColor: colors.background_card,
    },
  });

export default EditAssessment;
